import { IconButton, IconType } from 'features/nekst-widgets';
import { WebhookSubscription } from 'nekst-api';
import React from 'react';
import { useShowContextRequired } from 'ui-builder';
import useSettingsNavigator from '../../../settingsNavigator';

export default function WebhookRequestLogEntriesButton() {
  const { data } = useShowContextRequired<WebhookSubscription>();

  const settingsNavigator = useSettingsNavigator();

  return (
    <IconButton
      type={IconType.PENCIL}
      onClick={() => {
        settingsNavigator.openWebhookRequestsLogPage(data!.id);
      }}
    />
  );
}
